import { useState } from 'react';
import emailjs from '@emailjs/browser';
import { toast } from 'sonner';
import { saveToSheet } from '../utils/sheetsWebhook';

const SERVICE_ID = 'service_kdzpah6';
const TEMPLATE_ID = 'template_lxs7d4d';
const PUBLIC_KEY = 'xDVA5SqO_I89rUM3v';

export const useEmailSubmit = ({ successMessage, errorMessage, sheetName }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  // buildParams(formData, formEl) must return { emailParams: {name,email,phone,message}, sheetRow: {...} }
  const submit = async (e, formRef, buildParams, onSuccess) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const formData = new FormData(formRef.current);
      const { emailParams, sheetRow } = buildParams(formData, formRef.current);
      await emailjs.send(SERVICE_ID, TEMPLATE_ID, emailParams, PUBLIC_KEY);
      saveToSheet(sheetName, sheetRow);
      toast.success(successMessage);
      formRef.current.reset();
      if (onSuccess) onSuccess();
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to send:', error);
      }
      toast.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, submit };
};
